export enum ProjectReviewType {
  Claims = 1,
}

export const displayProjectReviewType = (value: ProjectReviewType) => {
  switch (value) {
    case ProjectReviewType.Claims:
      return 'Claims';
  }
};
